<template>
  <EmailVerificationShared type="account" />
</template>

<script setup>
import EmailVerificationShared from '@/components/EmailVerificationShared.vue'
</script>
